import { Box, IconButton, Paper, Stack, TextField, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

interface Props {
    block: SpacerBlock;
    onChange: (content: any) => void;
    onDelete: () => void;
}

const SpacerBlockEditor = ({ block, onChange, onDelete }: Props) => {
    return (
        <Paper sx={{ p: 2, mb: 2 }}>
            <Stack direction="row" spacing={1} alignItems="flex-start">
                <IconButton size="small" sx={{ cursor: "grab" }}>
                    <DragIndicatorIcon />
                </IconButton>
                <Box flex={1}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
                        Spacer Block
                    </Typography>
                    <Stack spacing={2}>
                        <TextField
                            label="Height"
                            value={block.content.height || "50px"}
                            onChange={(e) =>
                                onChange({
                                    ...block.content,
                                    height: e.target.value,
                                })
                            }
                            fullWidth
                            size="small"
                            helperText="e.g., 50px, 2rem, 10vh"
                        />
                    </Stack>
                </Box>
                <IconButton size="small" onClick={onDelete} color="error">
                    <DeleteIcon />
                </IconButton>
            </Stack>
        </Paper>
    );
};

export default SpacerBlockEditor;
